import { SignupSidebar } from '../../components/signup/SignupSidebar';
import { SignupLayout } from "../../components/signup/SignupLayout";
import { SelfSignupProvider } from '../../components/signup/state/SelfSignup';
import UserMerchantForm from './UserMerchantForm';
import { useUserLogout } from '../../hooks/useUserLogout';

const CreateUserMerchant = () => {
    const { logout } = useUserLogout();
    return (
        <SelfSignupProvider>
            <SignupLayout 
                logout={logout}
                SidebarComponent={SignupSidebar}
            >
                <UserMerchantForm />
            </SignupLayout>
        </SelfSignupProvider>
        
    )
}

export default CreateUserMerchant;